import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { share } from 'rxjs';
import WebSocketClient from "./client";
import { noop } from "../../type";
var Print = /*#__PURE__*/function (_WebSocketClient) {
  _inheritsLoose(Print, _WebSocketClient);
  function Print(opt) {
    var _this$messages;
    var _this;
    if (opt === void 0) {
      opt = {
        url: '',
        wetConnectRetry: null
      };
    }
    var defaultUrl = 'ws://localhost:5009';
    var _opt = opt,
      _opt$url = _opt.url,
      url = _opt$url === void 0 ? defaultUrl : _opt$url,
      _opt$wetConnectRetry = _opt.wetConnectRetry,
      wetConnectRetry = _opt$wetConnectRetry === void 0 ? 0 : _opt$wetConnectRetry;
    _this = _WebSocketClient.call(this, {
      url: url,
      name: '华为商城打印'
    }) || this;
    _this.messages$ = void 0;
    _this.input$ = void 0;
    _this.isReady = false;
    _this.WET_MAX_ATTEMPTS = wetConnectRetry;
    _this.messages$ = (_this$messages = _this.messages) === null || _this$messages === void 0 ? void 0 : _this$messages.pipe(share());
    _this.input$ = _this.input;
    return _this;
  }
  var _proto = Print.prototype;
  _proto.doPrint = function doPrint(data) {
    var _this$input$;
    (_this$input$ = this.input$) === null || _this$input$ === void 0 ? void 0 : _this$input$.next(typeof data === 'string' ? data : JSON.stringify(data));
  };
  _proto.subscribe = function subscribe(callback) {
    var _this$messages$;
    if (callback === void 0) {
      callback = noop;
    }
    var subscription = (_this$messages$ = this.messages$) === null || _this$messages$ === void 0 ? void 0 : _this$messages$.subscribe({
      next: function next(data) {
        return callback({
          success: true,
          data: data
        });
      },
      error: function error(_error) {
        return callback({
          success: false,
          data: {},
          error: {
            message: _error.message
          }
        });
      },
      complete: function complete() {
        return callback({
          success: true,
          data: {},
          complete: true
        });
      }
    });
    return function () {
      subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    };
  };
  return Print;
}(WebSocketClient);
Print.bussinessType = 1;
export default Print;